import ContactForm from './contact/ContactForm'

function Roadmap() {
    return (
        <div className="bg-white pb-8">
            <div className="max-w-4xl mx-auto px-4 py-16">
                <h1 className="text-2xl font-medium text-gray-900 mb-2">
                    Roadmap
                </h1>
                <p className="text-gray-600 mb-8">
                    Coming soon
                </p>
                <p className="text-gray-600 mb-6">In the meantime, submit your feedback to help me prioritise what to build next.</p>

                {/* Contact Form */}
                <ContactForm />
            </div>
        </div>
    )
}

export default Roadmap
